export enum RequestTypeEnum {
  TRIGGER = 'trigger',
  VIEW = 'view',
  ACTION = 'action',
  CONTRIBUTE = 'contribute',
}
